import { ChangeEvent, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { initialValues } from "./InitialValues";
import IService from "../../types/Content";
import ContentService from "../../services/ContentService";
import SimpleMDE from "react-simplemde-editor";
import { toast } from "react-toastify";

const UpdateService = () => {
  const { slug } = useParams();
  let navigate = useNavigate();

  const [card, setCard] = useState<IService>(initialValues);
  const [loading, setLoading] = useState<Boolean>(false);

  const getService = (slug: string) => {
    ContentService.get(slug)
      .then((response: any) => {
        setCard(response.data.data.service);
      })
      .catch((e: Error) => {
        console.log(e);
      });
  };

  useEffect(() => {
    if (slug) getService(slug);
  }, [slug]);

  const handleInputChange = (
    event: ChangeEvent<HTMLInputElement> | string,
    name: string
  ) => {
    console.log(event);
    setCard({ ...card, [name]: event });
  };

  const updateCard = () => {
    setLoading(true);
    ContentService.update(card?._id, card)
      .then((response: any) => {
        if (response.data.status === "success") {
          setLoading(false);
          toast.success("Updated successfully");
          navigate("/");
        }
      })
      .catch((e: Error) => {
        console.log(e);
      });
  };

  return (
    <div>
      <h1 className="d-flex align-items-center text-dark fw-bolder my-1 fs-3">
        Update card
      </h1>
      <div className="modal-body py-10 px-lg-17">
        <div className="scroll-y me-n7 pe-7">
          <div className="fv-row mb-7 fv-plugins-icon-container">
            <label className="required fs-6 fw-bold mb-2">Title Ru</label>
            <input
              type="text"
              className="form-control form-control-solid"
              placeholder=""
              name="titleRu"
              value={card.titleRu}
              onChange={(e) => handleInputChange(e.target.value, "titleRu")}
            />
            <div className="fv-plugins-message-container invalid-feedback"></div>
          </div>
          <div className="fv-row mb-7 fv-plugins-icon-container">
            <label className="required fs-6 fw-bold mb-2">Title Uzk</label>
            <input
              type="text"
              className="form-control form-control-solid"
              placeholder=""
              name="titleUzk"
              value={card.titleUzk}
              onChange={(e) => handleInputChange(e.target.value, "titleUzk")}
            />
            <div className="fv-plugins-message-container invalid-feedback"></div>
          </div>
          <div className="row g-9 mb-7">
            <div className="fv-row fv-plugins-icon-container">
              <label className="required fs-6 fw-bold mb-2">Title Uz</label>
              <input
                className="form-control form-control-solid"
                placeholder=""
                name="titleUz"
                onChange={(e) => handleInputChange(e.target.value, "titleUz")}
                value={card.titleUz}
              />
              <div className="fv-plugins-message-container invalid-feedback"></div>
            </div>
          </div>
          <div className="row g-9 mb-7">
            <div className="col-md-6 fv-row fv-plugins-icon-container">
              <label className="required fs-6 fw-bold mb-2">Slug</label>
              <input
                className="form-control form-control-solid"
                placeholder=""
                name="slug"
                onChange={(e) => handleInputChange(e.target.value, "slug")}
                value={card.slug}
              />
              <div className="fv-plugins-message-container invalid-feedback"></div>
            </div>
            <div className="col-md-6 fv-row fv-plugins-icon-container">
              <label className="required fs-6 fw-bold mb-2">Cover Image</label>
              <input
                className="form-control form-control-solid"
                placeholder=""
                name="coverImage"
                onChange={(e) =>
                  handleInputChange(e.target.value, "coverImage")
                }
                value={card.coverImage}
              />
              <img src={card.coverImage} alt="coverImage" width="100%" />
              <div className="fv-plugins-message-container invalid-feedback"></div>
            </div>
          </div>
          <div className="row g-9 mb-7">
            <div className="fv-row fv-plugins-icon-container">
              <label className="required fs-6 fw-bold mb-2">Content Ru</label>
              <SimpleMDE
                value={card.contentRu}
                onChange={(e) => handleInputChange(e, "contentRu")}
              />
              <div className="fv-plugins-message-container invalid-feedback"></div>
            </div>
          </div>
          <div className="row g-9 mb-7">
            <div className="fv-row fv-plugins-icon-container">
              <label className="required fs-6 fw-bold mb-2">Content Uzk</label>
              <SimpleMDE
                value={card.contentUzk}
                onChange={(e) => handleInputChange(e, "contentUzk")}
              />
              <div className="fv-plugins-message-container invalid-feedback"></div>
            </div>
          </div>
          <div className="row g-9 mb-7">
            <div className="fv-row fv-plugins-icon-container">
              <label className="required fs-6 fw-bold mb-2">Content Uz</label>
              <SimpleMDE
                value={card.contentUz}
                onChange={(e) => handleInputChange(e, "contentUz")}
              />
              <div className="fv-plugins-message-container invalid-feedback"></div>
            </div>
          </div>
          <div className="fv-row mb-7 fv-plugins-icon-container">
            <label className="required fs-6 fw-bold mb-2">For</label>
            <input
              type="text"
              className="form-control form-control-solid"
              placeholder=""
              name="for"
              value={card.for}
              onChange={(e) => handleInputChange(e.target.value, "for")}
            />
            <div className="fv-plugins-message-container invalid-feedback"></div>
          </div>
          <div className="row justify-content-end">
            <button
              className="btn btn-primary d-flex ml-auto"
              style={{
                width: "fit-content",
              }}
              onClick={updateCard}
            >
              Submit
              <span className={`indicator-${loading ? "label" : "progress"}`}>
                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdateService;
